import React, { useState } from "react";
import Modal from "../../../../../components/Modal/Modal";
import Button from "../../../../../components/Button/Button";
import VerbacallIcon from "../../../../../assets/svg/verbacall-icon";

interface CallLeadConfirmationModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => Promise<void>;
  leadName: string;
}

const CallLeadConfirmationModal: React.FC<CallLeadConfirmationModalProps> = ({
  open,
  onOpenChange,
  onConfirm,
  leadName,
}) => {
  const [isDialing, setIsDialing] = useState(false);

  const handleConfirm = () => {
    setIsDialing(true);
    onConfirm().then(() => {
      onOpenChange(false);
      setIsDialing(false);
    });
  };
  return (
    <Modal
      open={open}
      onOpenChange={onOpenChange}
      showHeader={false}
      contentClassName="w-[350px] min-h-[190px] border border-border-gray dark:border-border-gray-dk bg-fixed-white dark:bg-popper-bg-dk backdrop-blur-[10px]"
      overlayClassName="bg-black/80"
    >
      <div className="flex flex-col gap-[24px] items-center justify-center text-center h-full">
        <div className="flex flex-col items-center justify-center gap-[16px]">
          <div className="w-[36px] h-[36px] bg-purple-card-bg dark:bg-purple-card-bg-dk  rounded-full flex items-center justify-center">
            <VerbacallIcon className="w-[24px] h-[24px] text-verba-lavender dark:text-verba-lavender-dk" />
          </div>
          <div className="flex flex-col items-center justify-center gap-[2px]">
            <h3 className="text-heading-text dark:text-heading-text-dk font-semibold text-md">
              Call {leadName}
            </h3>
            <p className="text-sm font-normal text-heading-text dark:text-heading-text-dk">
              Are you sure you want to call {leadName}
            </p>
          </div>
        </div>
        <div className="flex items-center justify-center gap-[12px]">
          <Button
            type="button"
            onClick={() => onOpenChange(false)}
            innerText="Cancel"
            buttonContainerClass="min-w-[110px] rounded-[8px] py-[4px] bg-transparent dark:bg-transparent-dk border border-verba-indigo dark:border-verba-indigo-dk"
            innerTextClass="text-md font-semibold text-verba-indigo dark:text-verba-indigo-dk"
          />
          <Button
            type="submit"
            innerText="Call"
            isLoading={isDialing}
            disabled={isDialing}
            onClick={handleConfirm}
            buttonContainerClass="min-w-[110px] rounded-[8px] py-[4px] bg-verba-indigo dark:bg-verba-indigo-dk border border-verba-indigo dark:border-verba-indigo-dk"
            innerTextClass="text-md font-semibold text-pure-white dark:text-pure-white-dk"
          />
        </div>
      </div>
    </Modal>
  );
};

export default CallLeadConfirmationModal;
